<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </a-config-provider>
</template>

<script>

import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN"

export default {
  name: 'App',
  data () {
    return {
      zh_CN
    }
  }
}
// window.onload = function() {
//   document.addEventListener('touchstart', function(event) {
//     if (event.touches.length > 1) {
//       event.preventDefault()
//     }
//   })
//   document.addEventListener('gesturestart', function(event) {
//     event.preventDefault()
//   })
// }
</script>

<style>
#app{
  -webkit-text-size-adjust:none;
  -webkit-tap-highlight-color:transparent;
  -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
  -webkit-user-select:none; /*webkit浏览器*/
  -khtml-user-select:none; /*早期浏览器*/
  -moz-user-select:none;/*火狐*/
  -ms-user-select:none; /*IE10*/
  user-select:none;
}
</style>
